import { InjectionToken } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { DoodShopModel } from '@core/models/shop.model';
import { IProductLabel, TreeCategoryWithProduct } from '@core/models/product.model';
import { TreeTab } from '@core/models/tab-list.model';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';
import { CatalogFilterOptions } from './catalog-filters';

export type ShopProductListBlockFilterColors = {
  banner?: IContentBuilderFieldColor;
  inactiveColors: ContentBuilderFieldColors;
  activeColors: ContentBuilderFieldColors;
};

/** Runtime VM emitted by `ShopProductListBlock` data sources. */
export type ShopProductListBlockViewModel = {
  shop: DoodShopModel | null;
  isShopLoading: boolean;
  cartProducts: unknown[];
  tagColors: ContentBuilderFieldColors;
  filterColors: ShopProductListBlockFilterColors;
  treeTabsOfCatalogCategory: TreeTab[];
  selectedLabel: IProductLabel | undefined;
  categoriesWithProductsFilteredByLabel: TreeCategoryWithProduct[];
  /** Label-filtered tree, before allergen and tag filters. Used to count the dialog CTA. */
  categoriesBeforeCatalogFilters?: TreeCategoryWithProduct[];
  catalogFilterOptions?: CatalogFilterOptions;
  categoriesId: string[];
  warningMessages?: string[];
};

export const SHOP_PRODUCT_LIST_BLOCK_LOADING_VM: ShopProductListBlockViewModel = {
  shop: null,
  isShopLoading: true,
  cartProducts: [],
  tagColors: {},
  filterColors: { inactiveColors: {}, activeColors: {} },
  treeTabsOfCatalogCategory: [],
  selectedLabel: undefined,
  categoriesWithProductsFilteredByLabel: [],
  categoriesId: [],
};

export interface ShopProductListBlockDataSource {
  readonly vm$: import('rxjs').Observable<ShopProductListBlockViewModel>;
  selectLabel(label: IProductLabel | undefined): void;
  setCatalogFiltersEnabled(enabled: boolean): void;
}

export const SHOP_PRODUCT_LIST_BLOCK_DATA_SOURCE =
  new InjectionToken<ShopProductListBlockDataSource>('SHOP_PRODUCT_LIST_BLOCK_DATA_SOURCE');
